import notice from './notice.vue'

export default notice
